import React from 'react';
import { LibraryBigIcon, BookOpenIcon, BadgeCheckIcon, SearchIcon, CheckIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { HERO_IMAGE, heroBadges, pillars } from '../../data/content';
const icons = {
  library: LibraryBigIcon,
  books: BookOpenIcon,
  check: BadgeCheckIcon,
  search: SearchIcon
};
export function Hero() {
  return <header className="relative overflow-hidden bg-ink-950 px-4 pb-10 pt-8 sm:pt-12" data-id="element-121" data-mp="mu0o8n575lt1">
      <div className="pointer-events-none absolute left-1/2 top-0 h-[420px] w-[420px] -translate-x-1/2 rounded-full bg-brand-600/20 blur-[110px]" aria-hidden="true" data-id="element-122" data-mp="ms7qjxckabx6" />
      <div className="relative mx-auto max-w-2xl lg:max-w-5xl" data-id="element-123" data-mp="vofcvgbma8ot">
        <div className="flex justify-center" data-id="element-124" data-mp="10kdv0m6cqugs">
          <span className="rounded-full border border-brand-500/40 bg-brand-500/10 px-3.5 py-1.5 text-[11px] font-black uppercase tracking-[0.16em] text-brand-400" data-id="element-125" data-mp="10n9rs76grd3n">
            Sistema Anti-Rifiniture™
          </span>
        </div>

        <h1 className="mt-5 text-center font-display text-[30px] leading-[1.08] text-white sm:text-5xl lg:text-[56px]" data-id="element-126" data-mp="9oc9aqbd7zjs">
          Riduci le Rifiniture e Aumenta la{' '}
          <span className="text-brand-400" data-id="element-127" data-mp="3vv108lvug06j">Prevedibilità</span> dei Tuoi Casi con gli
          Allineatori
        </h1>

        <p className="mx-auto mt-4 max-w-xl text-center text-[15px] leading-relaxed text-white/70 sm:text-lg" data-id="element-128" data-mp="3rtxl61lme86d">
          Il sistema clinico di consultazione rapida che ti aiuta a individuare gli errori
          prima che diventino un problema, ottimizzare ogni pianificazione e portare a
          termine più trattamenti con meno tempo, meno complicazioni e maggiore
          redditività.
        </p>

        <div className="mt-7" data-id="element-129" data-mp="enfecarci5rr">
          <img src={HERO_IMAGE} alt="Sistema Anti-Rifiniture™ – 6 volumi clinici, tablet, smartphone e mappa decisionale" className="mx-auto w-full max-w-lg" loading="eager" data-id="element-130" data-mp="eme1c0qrr97e" />
        </div>

        <div className="mx-auto mt-6 max-w-md" data-id="element-131" data-mp="30lxiana1wz31">
          <CTAButton id="hero-cta" label="Voglio il Sistema Anti-Rifiniture™" sublabel="Download immediato · Accesso a vita" data-id="element-132" data-mp="30n8kwjrrg0sk" />
        </div>

        <ul className="mx-auto mt-6 grid max-w-md grid-cols-2 gap-2" data-id="element-133" data-mp="2qv2uheh5prfh">
          {heroBadges.map(badge => <li key={badge} className="flex items-center gap-2 rounded-xl border border-white/10 bg-ink-900 px-3 py-2.5 text-[12px] font-semibold leading-tight text-white/80 sm:text-sm" data-id="element-134" data-mp="2vtmf9bk0kx69">
              <CheckIcon className="h-4 w-4 shrink-0 text-brand-400" aria-hidden="true" data-id="element-135" data-mp="2ms63p0hgqp0g" />
              {badge}
            </li>)}
        </ul>

        <div className="mt-10 grid gap-3 sm:grid-cols-2" data-id="element-136" data-mp="2cxe4xtc59w43">
          {pillars.map(pillar => {
          const Icon = icons[pillar.icon];
          return <div key={pillar.title} className="flex h-full flex-col rounded-2xl border border-white/10 bg-ink-900 p-4" data-id="element-137" data-mp="b4pzrefxwylo">
                <Icon className="h-6 w-6 text-brand-400" aria-hidden="true" data-id="element-138" data-mp="1vkxu2qc0r1k8" />
                <h2 className="mt-3 text-base font-extrabold text-white" data-id="element-139" data-mp="1qpiiy65ebjri">{pillar.title}</h2>
                <p className="mt-1.5 text-[13px] leading-relaxed text-white/60" data-id="element-140" data-mp="25dlr9m6wv7jh">
                  {pillar.text}
                </p>
              </div>;
        })}
        </div>
      </div>
    </header>;
}